export default {
    allLocations: state => state.allLocations,
    searchedLocations: state => state.searchedLocations,
    location: state => state.location,
    locationAddress: state => state.locationAddress,
    users: state => state.users,

    // location Groups
    allLocationGroups: state => state.allLocationGroups,
    locationGroupWithLocations: state => state.locationGroupWithLocations
}
